export default function UsageBadge({ used, limit, label }) {
  if (limit >= 999999) return null;
  const pct = limit > 0 ? Math.min((used / limit) * 100, 100) : 100;
  const color =
    pct >= 90 ? "from-red-500 to-red-600" :
    pct >= 70 ? "from-amber-500 to-orange-500" :
    "from-emerald-500 to-teal-500";

  return (
    <div className="flex items-center gap-2 text-xs text-gray-400">
      <span className="whitespace-nowrap">{label}: {used}/{limit >= 999999 ? "∞" : limit}</span>
      <div className="flex-1 h-1.5 bg-gray-700 rounded-full overflow-hidden min-w-[40px]">
        <div
          className={`h-full rounded-full bg-gradient-to-r ${color} transition-all duration-500`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
